import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-marker_move",
  "use": "icon-marker_move-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-marker_move\">\r\n  <path d=\"M575.488 189.472l0 258.016 256 0 0-128L1024 512l-192.512 192.48 0-130.976-256 0 0 258.016 128.992 0L512 1024l-192.512-192.48 128 0 0-258.016-256 0 0 129.984L0 512l191.488-191.488 0 126.976 256 0L447.488 189.472l-124.992 0L512 0l189.504 189.472L575.488 189.472z\" p-id=\"2412\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol